// extracted by mini-css-extract-plugin
export default {"Popper":"InformationIcon_Popper__GlArW","PickerHeaderIcon":"InformationIcon_PickerHeaderIcon__9WGiZ"};